// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__-b2JY","header":"ReportDetails_header__puQCV","title":"ReportDetails_title__2bSkJ","left":"ReportDetails_left__3UduB"};